<div
	(click)="this._onChangeEvent($event)"
	matRipple
>
	<div
		class="event-filter-item flex flex-row items-center justify-start gap-3"
		mat-list-item
	>
		<mat-checkbox
			(change)="this._onChangeEvent($event)"
			(click)="$event.preventDefault()"
			[checked]="this.checked"
			class="event-filter-item-check"
			color="primary"
		></mat-checkbox>
		<span
			[innerText]="this.title | translate"
			class="truncate"
		></span>
		<img
			[src]="this.image | safeUrl"
			*ngIf="this.image"
			class="event-filter-item-icon"
		>
	</div>
</div>
